const LANG_PREFERRED_REGION = {
  en: 'US',
  fr: 'FR',
  de: 'DE',
  es: 'ES',
  it: 'IT',
  pt: 'PT',
  sv: 'SE',
  fi: 'FI',
  da: 'DK',
  no: 'NO',
  nl: 'NL',
};

function hreflangTag(lang, regionCode, includeRegionalVariants) {
  const l = String(lang || 'en').toLowerCase();
  const code = String(regionCode || 'US').toLowerCase();
  return includeRegionalVariants ? `${l}-${code}` : l;
}

/**
 * Build hreflang alternate URLs from active regions.
 * With regional variants (default): one URL per country market (~18 locales).
 */
export function buildRegionalSeoAlternates(regions, pagePath = '/', includeRegionalVariants = true) {
  const normalizedPath =
    pagePath === '/' || !pagePath ? '/' : pagePath.startsWith('/') ? pagePath : `/${pagePath}`;

  const availableLanguages = {};
  const alternateUrls = {};
  const seen = new Set();

  (regions || [])
    .filter((region) => region?.isActive !== false)
    .forEach((region) => {
      const lang = (region.defaultLanguage || 'en').toLowerCase();
      const code = String(region.code || 'US').toUpperCase();
      const tag = hreflangTag(lang, code, includeRegionalVariants);

      if (!includeRegionalVariants) {
        const preferred = LANG_PREFERRED_REGION[lang] || 'US';
        if (code !== preferred || seen.has(lang)) return;
        seen.add(lang);
      } else if (seen.has(tag)) {
        return;
      } else {
        seen.add(tag);
      }

      availableLanguages[tag] = { code: lang, region: code };
      const regionCode = code.toLowerCase();
      alternateUrls[tag] =
        !regionCode || regionCode === 'us'
          ? normalizedPath
          : normalizedPath === '/'
            ? `/${regionCode}`
            : `/${regionCode}${normalizedPath}`;
    });

  return { availableLanguages, alternateUrls };
}
